<template>
  <v-container v-if="$can('browse-sales', 'Yacht')">
    <v-row
      no-gutters
      align="center"
      class="mb-6"
    >
      <v-col>
        <div class="headline">
          Yacht Sales
        </div>
      </v-col>
      <v-col
        v-if="$can('create', 'Yacht')"
        cols="auto"
      >
        <v-btn
          color="primary"
          class="ma-0"
          @click="openYachtEditDialog()"
        >
          <v-icon left>
            add
          </v-icon>
          Start New Sales
        </v-btn>
      </v-col>
      <v-col
        v-if="$can('create', 'YachtSalesSlot')"
        cols="auto"
        class="pl-2"
      >
        <v-btn
          class="ma-0"
          @click="yachtSalesSlots.edit.slot = undefined; yachtSalesSlots.edit.dialog = true"
        >
          <v-icon left>
            add
          </v-icon>
          Add Yard Stock
        </v-btn>
      </v-col>
    </v-row>

    <v-tabs
      background-color="transparent"
      class="ma-0"
    >
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'my-sales' }}"
        exact
      >
        My Sales
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'slots' }}"
        exact
      >
        Yard Stock
        <v-chip
          label
          outlined
          small
          :color="yachtSalesSlots.count > 0 ? 'primary' : 'grey'"
          class="px-2 ml-2"
        >
          {{ yachtSalesSlots.count }}
        </v-chip>
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'unsold' }}"
        exact
      >
        Stock In Fleet
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'sales' }}"
        exact
      >
        In Sales
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'approval' }}"
        exact
      >
        Approval Required
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'approved' }}"
        exact
      >
        Approved
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'reserved' }}"
        exact
      >
        Reserved
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'yachtSales', query: { view: 'sold' }}"
        exact
      >
        Sold
      </v-tab>
    </v-tabs>
    <v-divider class="mb-6" />

    <v-row>
      <v-col
        v-if="currentView !== 'slots'"
        cols="3"
      >
        <div style="position: sticky; top: 20px">
          <v-subheader class="justify-space-between pr-0">
            Filters
            <v-btn
              v-if="isFiltered"
              text
              color="red"
              @click="clearFilters"
            >
              <v-icon
                small
                left
              >
                close
              </v-icon>
              Clear
            </v-btn>
          </v-subheader>
          <!--          <v-switch-->
          <!--            v-model="filtersDirty.my_yachts"-->
          <!--            label="My Yachts Only"-->
          <!--            dense-->
          <!--          />-->
          <v-text-field
            v-model="filtersDirty.id"
            solo
            dense
            type="number"
            label="ID"
            hide-details
            clearable
            class="mb-2"
            autocomplete="no"
          />
          <v-text-field
            v-model="filtersDirty.name"
            solo
            dense
            label="Name"
            hide-details
            clearable
            class="mb-2"
            autocomplete="no"
          />
          <v-text-field
            v-model="filtersDirty.hull_number"
            solo
            dense
            hide-details
            label="Hull Number"
            clearable
            class="mb-2"
          />
          <v-autocomplete
            v-model="filtersDirty.investment_status"
            solo
            multiple
            dense
            hide-details
            label="Sales Status"
            :items="allInvestmentStatuses"
            class="mb-2"
          />
          <v-autocomplete
            v-model="filtersDirty.status"
            solo
            dense
            multiple
            hide-details
            label="Logistics Status"
            :items="allLogisticsStatuses"
            class="mb-2"
          />
          <v-autocomplete
            v-model="filtersDirty.owner_id"
            solo
            hide-details
            dense
            label="Yacht owner"
            clearable
            :items="owners.data"
            :loading="owners.loading"
            item-value="id"
            item-text="name"
            class="mb-2"
          />
          <v-autocomplete
            v-model="filtersDirty.yacht_manufacturer_id"
            solo
            hide-details
            clearable
            label="Yacht Manufacturer"
            dense
            :items="manufacturers.data"
            :loading="manufacturers.loading"
            item-value="id"
            item-text="name"
            autocomplete="off"
            class="mb-2"
          />
          <yacht-model-select
            v-model="filtersDirty.yacht_model_id"
            solo
            hide-details
            label="Yacht Model"
            dense
            clearable
            :items="yachtModelsData"
            :loading="yachtModels.loading"
            class="mb-2"
          />
          <v-autocomplete
            v-model="filtersDirty.country_id"
            solo
            hide-details
            clearable
            label="Country"
            dense
            :items="countries.data"
            :loading="countries.loading"
            item-value="id"
            item-text="name"
            autocomplete="off"
            class="mb-2"
          />
          <v-text-field
            v-model="filtersDirty.delivery_year"
            solo
            type="number"
            label="Delivery Year"
            dense
            hide-details
            clearable
            class="mb-2"
          />
          <v-text-field
            v-model="filtersDirty.ex_factory_year"
            solo
            type="number"
            label="Ex Factory Year"
            dense
            hide-details
            clearable
            class="mb-2"
          />
          <v-text-field
            v-model="filtersDirty.phase_out_year"
            solo
            type="number"
            label="Phase Out Year"
            dense
            hide-details
            clearable
            class="mb-2"
          />
          <v-select
            v-model="filtersDirty.finance_model_type"
            class="mb-2"
            solo
            label="Investment Model"
            :items="financeModelTypes.data"
            :loading="financeModelTypes.loading"
            item-text="name"
            item-value="type"
            hide-details
            clearable
            dense
          />
          <assignee-modal-select
            v-model="salesRep"
            solo
            label="Sales representative"
            hide-details
            clearable
            dense
            type="staff"
          />
        </div>
      </v-col>
      <v-col
        v-else
        cols="3"
      >
        <div style="position: sticky; top: 20px">
          <v-subheader class="justify-space-between pr-0">
            Filters
          </v-subheader>
          <v-text-field
            v-model="yachtSalesSlots.filtersDirty.yard_id"
            solo
            label="Slot Yard ID"
            dense
            hide-details
            clearable
            class="mb-2"
          />
          <v-autocomplete
            v-model="yachtSalesSlots.filtersDirty.yacht_manufacturer_id"
            solo
            hide-details
            clearable
            label="Yacht Manufacturer"
            dense
            :items="manufacturers.data"
            :loading="manufacturers.loading"
            item-value="id"
            item-text="name"
            autocomplete="off"
            class="mb-2"
          />
          <v-text-field
            v-model="yachtSalesSlots.filtersDirty.yacht_model"
            solo
            label="Yacht Model"
            dense
            hide-details
            clearable
            class="mb-2"
          />
          <v-text-field
            v-model="yachtSalesSlots.filtersDirty.ex_factory_year"
            solo
            type="number"
            label="Ex Factory Year"
            dense
            hide-details
            clearable
            class="mb-2"
          />

          <v-subheader>
            Sales Slot Status
          </v-subheader>
          <button-group
            v-model="yachtSalesSlots.filtersDirty.status"
            :items="[ { value: 'open', text: 'Open' }, { value: 'closed', text: 'Closed' }]"
            dense
            class="text-none"
          />
        </div>
      </v-col>
      <v-col
        v-if="currentView !== 'slots'"
        cols="13"
      >
        <!--<editor-fold desc="Pagination header">-->
        <pagination
          :from="yachts.meta.from"
          :to="yachts.meta.to"
          :total="yachts.meta.total"
          :last-page="yachts.meta.last_page"
          :page.sync="pagination.page"
          class="mb-1 align-end"
        />
        <!--</editor-fold>-->
        <!--<editor-fold desc="Table">-->
        <v-data-table
          :headers="tableHeaders"
          :items="yachts.data"
          :loading="yachts.loading"
          :page.sync="pagination.page"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.desc"
          :server-items-length="yachts.meta.total"
          must-sort
          hide-default-footer
          class="elevation-5"
        >
          <template v-slot:item="{ item }">
            <sales-row
              :yacht="item"
              :show-sales-rep="currentView !== 'my-sales'"
            />
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <div
              v-if="isFiltered"
              class="text-center py-4"
            >
              <div>
                There are no results for your search.
              </div>
              <div
                class="mt-2"
              >
                <v-btn
                  small
                  text
                  @click="clearFilters()"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </div>
            </div>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <div
              v-else
              class="text-center py-4"
            >
              <v-col cols="16">
                There are no yachts at the moment.
              </v-col>
              <v-col
                cols="16"
                class="mt-2"
              >
                <v-btn
                  color="primary"
                  small
                  @click="openYachtEditDialog()"
                >
                  <v-icon left>
                    add
                  </v-icon>
                  New Yacht Sales
                </v-btn>
              </v-col>
            </div>
            <!--</editor-fold>-->
          </template>
        </v-data-table>
        <!--</editor-fold>-->

        <pagination
          :from="yachts.meta.from"
          :to="yachts.meta.to"
          :total="yachts.meta.total"
          :last-page="yachts.meta.last_page"
          :page.sync="pagination.page"
          class="mt-1 align-center"
        />
      </v-col>
      <v-col
        v-else
        cols="13"
      >
        <!--<editor-fold desc="Pagination header">-->
        <pagination
          :from="yachtSalesSlots.meta.from"
          :to="yachtSalesSlots.meta.to"
          :total="yachtSalesSlots.meta.total"
          :last-page="yachtSalesSlots.meta.last_page"
          :page.sync="yachtSalesSlots.pagination.page"
          class="mb-1 align-end"
        />
        <!--</editor-fold>-->
        <!--<editor-fold desc="Table">-->
        <v-data-table
          :headers="tableHeaders"
          :items="yachtSalesSlots.data"
          :loading="yachtSalesSlots.loading"
          :page.sync="yachtSalesSlots.pagination.page"
          :sort-by.sync="yachtSalesSlots.sorting.sortBy"
          :sort-desc.sync="yachtSalesSlots.sorting.desc"
          :server-items-length="yachtSalesSlots.meta.total"
          hide-default-footer
          :multi-sort="false"
          must-sort
          class="elevation-5"
        >
          <template v-slot:item="{ item }">
            <tr
              class="clickable"
              @click="yachtSalesSlots.view.salesSlotId = item.id; yachtSalesSlots.view.visible = true"
            >
              <td>
                <span v-if="item.yard_id">{{ item.yard_id }}</span>
                <span
                  v-else
                  class="grey--text"
                >N/A</span>
              </td>
              <td class="text-no-wrap">
                <div
                  v-if="!item.yacht_model"
                  class="grey--text text--lighten-1"
                >
                  N/A
                  <div
                    v-if="item.yacht_manufacturer"
                    class="font-weight-light grey--text text--darken-2"
                  >
                    {{ item.yacht_manufacturer.name }}
                  </div>
                </div>
                <div
                  v-else
                  style="max-width: 150px; text-overflow: ellipsis; overflow: hidden"
                >
                  {{ item.yacht_model }}
                  <div class="font-weight-light grey--text text--darken-2">
                    {{ item.yacht_manufacturer.name }}
                  </div>
                </div>
              </td>
              <td>
                {{ item.ex_factory_date | moment('D MMM YYYY') }}
              </td>
              <td>
                <span v-if="item.last_order_date">{{ item.last_order_date | moment('D MMM YYYY') }}</span>
                <span
                  v-else
                  class="grey--text"
                >N/A</span>
              </td>
              <td class="caption grey--text">
                {{ item.note }}
              </td>
              <td :class="{ 'font-weight-bold': item.yachts_count > 0, 'grey--text': item.yachts_count === 0}">
                {{ item.yachts_count }}
              </td>
              <td class="text-no-wrap">
                <div
                  v-if="item.yachts_reserved.length === 0"
                  class="grey--text"
                >
                  N/A
                </div>
                <div v-else>
                  <div
                    v-for="yacht in item.yachts_reserved"
                    :key="'reserved' + yacht.id"
                  >
                    <router-link :to="{ name: 'yachtDashboard', params: { id: yacht.id }}">
                      #{{ yacht.id }} &middot; {{ yacht.name || 'No Name' }}
                    </router-link>
                  </div>
                </div>
              </td>
              <td class="text-no-wrap">
                <div
                  v-if="item.yachts_sold.length === 0"
                  class="grey--text"
                >
                  N/A
                </div>
                <div v-else>
                  <div
                    v-for="yacht in item.yachts_sold"
                    :key="'reserved' + yacht.id"
                  >
                    <router-link :to="{ name: 'yachtDashboard', params: { id: yacht.id }}">
                      #{{ yacht.id }} &middot; {{ yacht.name || 'No Name' }}
                    </router-link>
                  </div>
                </div>
              </td>
              <td>
                <v-chip
                  class="ma-0"
                  small
                  label
                  color="transparent"
                  :text-color="item.partners_visible ? 'success' : 'grey'"
                >
                  <v-avatar>
                    <v-icon
                      style="font-size: 14px"
                      :color="item.partners_visible ? 'success' : 'grey'"
                    >
                      {{ item.partners_visible ? 'fa fa-check' : 'fa fa-times' }}
                    </v-icon>
                  </v-avatar>
                  {{ item.partners_visible ? 'Yes' : 'No' }}
                </v-chip>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <div
              v-if="isFiltered"
              class="text-center py-4"
            >
              <div>
                There are no results for your search.
              </div>
              <div
                class="mt-2"
              >
                <v-btn
                  small
                  text
                  @click="clearFilters()"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </div>
            </div>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <div
              v-else
              class="text-center py-4"
            >
              <v-col cols="16">
                There are no stock slots at the moment.
              </v-col>
            </div>
            <!--</editor-fold>-->
          </template>
        </v-data-table>
        <!--</editor-fold>-->

        <pagination
          :from="yachtSalesSlots.meta.from"
          :to="yachtSalesSlots.meta.to"
          :total="yachtSalesSlots.meta.total"
          :last-page="yachtSalesSlots.meta.last_page"
          :page.sync="yachtSalesSlots.pagination.page"
          class="mt-1 align-center"
        />
      </v-col>
    </v-row>

    <yacht-edit-dialog
      v-if="$can('create', 'Yacht')"
      :visible.sync="yachtEditDialog"
      @update:yacht="yachtCreated"
    />

    <yacht-sales-slot-edit-dialog
      v-if="$can('create', 'YachtSalesSlot') || $can('edit', 'YachtSalesSlot')"
      :sales-slot="yachtSalesSlots.edit.slot"
      :visible.sync="yachtSalesSlots.edit.dialog"
      @update:sales-slot="fetchYachtSalesSlots()"
    />

    <yacht-sales-slot-view-dialog
      :sales-slot-id="yachtSalesSlots.view.salesSlotId"
      :visible.sync="yachtSalesSlots.view.visible"
      @updated:sales-slot="fetchYachtSalesSlots()"
      @deleted:sales-slot="fetchYachtSalesSlots()"
    />
  </v-container>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import paginationMixin from '@/mixins/paginationMixin'
import filterableMixin from '@/mixins/filterableMixin'
import Owner from '@/models/Owner'
import Yacht from '@/models/Yacht'
import YachtModel from '@/models/YachtModel'
import YachtEditDialog from '@/components/business/yachts/YachtEditDialog'
import debounce from 'lodash/debounce'
import YachtModelSelect from '@/components/helpers/YachtModelSelect'
import SalesRow from '@/components/business/yachts/SalesRow'
import YachtSalesSlot from '@/models/YachtSalesSlot'
import YachtSalesSlotEditDialog from '@/components/business/yachts/YachtSalesSlotEditDialog'
import YachtSalesSlotViewDialog from '@/components/business/yachts/YachtSalesSlotViewDialog'
import ButtonGroup from '@/components/helpers/ButtonGroup'
import FinanceModel from '@/models/FinanceModel'
import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect.vue'

export default {
  name: 'YachtSalesIndex',
  components: {
    AssigneeModalSelect,
    ButtonGroup,
    YachtSalesSlotViewDialog,
    YachtSalesSlotEditDialog,
    SalesRow,
    YachtModelSelect,
    YachtEditDialog
  },
  mixins: [paginationMixin, filterableMixin],
  data() {
    return {
      yachts: {
        data: [],
        loading: false,
        meta: {}
      },
      yachtSalesSlots: {
        count: null,
        data: [],
        loading: false,
        meta: {},
        pagination: {
          page: 1,
          perPage: 25
        },
        sorting: {
          sortBy: 'ex_factory_date',
          desc: false
        },
        filtersClean: YachtSalesSlot.emptyFilters,
        filtersDirty: cloneDeep(YachtSalesSlot.emptyFilters),
        edit: {
          dialog: false,
          slot: undefined
        },
        view: {
          salesSlotId: undefined,
          visible: false
        }
      },
      yachtModels: {
        data: [],
        loading: false
      },
      owners: {
        data: [],
        loading: false
      },
      financeModelTypes: {
        data: [],
        loading: false
      },
      yachtEditDialog: false,
      filtersClean: Yacht.emptyFilters,
      filtersDirty: cloneDeep(Yacht.emptyFilters),
      salesRep: undefined
    }
  },
  computed: {
    currentView() {
      return this.$route.query.view
    },
    tableHeaders() {
      if (this.currentView === 'slots') {
        return [
          { text: 'Yard ID', value: 'yard_id', sortable: true, width: '1px' },
          { text: 'Yacht Model', value: 'full_label', sortable: true, width: '1%' },
          { text: 'Ex Factory Date', value: 'ex_factory_date', sortable: true, width: '1%' },
          { text: 'Last Order / Production Date', value: 'last_order_date', sortable: true, width: '1%' },
          { text: 'Note', value: 'note', sortable: false },
          { text: 'Opened Sales', value: 'yachts_count', sortable: false, width: '1px' },
          { text: 'Reserved', value: 'yachts_sold', sortable: false, width: '1px' },
          { text: 'Sold', value: 'yachts_sold', sortable: false, width: '1px' },
          { text: 'Partners visible', value: 'partners_visible', sortable: true, width: '1px' }
        ]
      }

      return [
        { text: 'ID', value: 'id', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Model', value: 'yacht_model_label', sortable: true },
        { text: 'Ex Factory', value: 'ex_factory_date', sortable: true },
        { text: 'Destination', value: 'current_base.name', sortable: false },
        { text: 'Sales', value: 'investment_status', sortable: false, width: '1%', class: 'px-0' },
        { text: 'Logistics', value: 'status', sortable: false, width: '1%', class: 'pl-2 pr-0' },
        { text: 'Investment model', value: 'finance_model_id', sortable: false },
        ...this.$can('view', 'Owner') ? [{ text: 'Yacht owner', value: 'owner.name', sortable: false }] : [],
        ...this.$can('view-sale-price', 'Yacht') ? [{ text: 'Price', value: 'total_sale_price', sortable: false }] : [],
        ...this.currentView !== 'my-sales' ? [{ text: 'Sales rep', value: 'sales_rep_id', sortable: false }] : []
      ]
    },
    countries() {
      return this.$store.getters['settings/charteringCountries']
    },
    manufacturers() {
      return this.$store.getters['settings/yachtManufacturers']
    },
    yachtModelsData() {
      return this.yachtModels.data.filter(ym => {
        if (!this.filtersDirty.yacht_manufacturer_id) return true

        return this.filtersDirty.yacht_manufacturer_id === ym.yacht_manufacturer_id
      })
    },
    allInvestmentStatuses() {
      return Yacht.allInvestmentStatuses()
    },
    allLogisticsStatuses() {
      return Yacht.allStatuses()
    }
  },
  watch: {
    currentView: function (view) {
      if (view === 'sales') {
        this.sorting.sortBy = 'ex_factory_date'
        this.sorting.desc = false
      }

      this.setFilters()
    },
    'yachtSalesSlots.sorting': {
      handler() {
        this.resetSlotsPagination()
      },
      deep: true
    },
    'yachtSalesSlots.pagination.page': function () {
      this.scrollToTop()
      this.onYachtSalesSlotsPaginationUpdate()
    },
    'yachtSalesSlots.filtersDirty': {
      handler: debounce(function () {
        this.onYachtSalesSlotsFiltersUpdate()
      }, 300),
      deep: true
    },
    salesRep: function (value) {
      if (value) this.filtersDirty.sales_rep_id = value.id
      else this.filtersDirty.sales_rep_id = null
    }
  },
  created() {
    // let allowedViews = [
    //   ...this.$can('browse-stocklist', 'Yacht') ? ['sales'] : [],
    //   ...this.$can('browse-pending-logistics', 'Yacht') ? ['pending-logistics'] : [],
    //   ...this.$can('browse-charter', 'Yacht') ? ['charter'] : []
    // ]

    const routeView = this.$route.query.view

    if (!routeView/* || allowedViews.indexOf(routeView) === -1 */) {
      this.$router.replace({
        name: 'yachtSales',
        query: {
          view: 'my-sales'
        }
      })
    }

    this.$nextTick(() => {
      this.setFilters()

      this.fetchYachts()
      this.fetchOwners()
      this.fetchYachtModels()

      this.fetchYachtSalesSlots()

      this.fetchFinanceModelTypes()
    })
  },
  methods: {
    setFilters() {
      if (this.currentView === 'my-sales') {
        this.filtersDirty.status = [Yacht.STATUS_DRAFT, Yacht.STATUS_PENDING, Yacht.STATUS_PLANNED, Yacht.STATUS_DELIVERY, Yacht.STATUS_IN_USE]
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_SALES, Yacht.INVESTMENT_STATUS_APPROVAL, Yacht.INVESTMENT_STATUS_APPROVED, Yacht.INVESTMENT_STATUS_RESERVED]
        this.filtersDirty.my_sales = true
      } else if (this.currentView === 'unsold') {
        this.filtersDirty.status = [Yacht.STATUS_PENDING, Yacht.STATUS_PLANNED, Yacht.STATUS_DELIVERY, Yacht.STATUS_IN_USE]
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_DRAFT, Yacht.INVESTMENT_STATUS_SALES, Yacht.INVESTMENT_STATUS_APPROVAL, Yacht.INVESTMENT_STATUS_APPROVED, Yacht.INVESTMENT_STATUS_RESERVED]
        this.filtersDirty.my_sales = false
      } else if (this.currentView === 'sales') {
        this.filtersDirty.status = undefined
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_SALES]
        this.filtersDirty.my_sales = false
      } else if (this.currentView === 'approval') {
        this.filtersDirty.status = undefined
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_APPROVAL]
        this.filtersDirty.my_sales = false
      } else if (this.currentView === 'approved') {
        this.filtersDirty.status = undefined
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_APPROVED]
        this.filtersDirty.my_sales = false
      } else if (this.currentView === 'reserved') {
        this.filtersDirty.status = undefined
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_RESERVED]
        this.filtersDirty.my_sales = false
      } else if (this.currentView === 'sold') {
        this.filtersDirty.status = undefined
        this.filtersDirty.investment_status = [Yacht.INVESTMENT_STATUS_SOLD]
        this.filtersDirty.my_sales = false
      }
    },
    onPaginationUpdate() {
      this.fetchYachts()
    },
    onFiltersUpdate() {
      this.resetPagination()
    },
    resetSlotsPagination() {
      this.scrollToTop()
      if (this.yachtSalesSlots.pagination.page === 1) {
        this.onYachtSalesSlotsPaginationUpdate()
        return
      }
      this.yachtSalesSlots.pagination.page = 1
    },
    onYachtSalesSlotsPaginationUpdate() {
      this.fetchYachtSalesSlots()
    },
    onYachtSalesSlotsFiltersUpdate() {
      this.resetSlotsPagination()
    },
    fetchYachts: debounce(async function () {
      this.yachts.loading = true

      let queryParams = {
        ...this.paginationQueryParams,
        ...this.filterQueryParams
      }

      try {
        let result = await Yacht.api.fetchYachts(queryParams)

        this.yachts.data = result.data
        this.yachts.meta = result.meta
      } catch (e) {
        this.$store.dispatch('alert', {
          'text': 'Something went wrong',
          'color': 'error'
        })
        throw e
      } finally {
        this.yachts.loading = false
      }
    }, 500),
    fetchYachtSalesSlots: debounce(async function () {
      this.yachtSalesSlots.loading = true

      let filters = {}

      for (let key of Object.keys(this.yachtSalesSlots.filtersDirty)) {
        const val = typeof this.yachtSalesSlots.filtersDirty[key] === 'string' ? this.yachtSalesSlots.filtersDirty[key].trim() : this.yachtSalesSlots.filtersDirty[key]

        if (!(val === undefined || val === null || val.length === 0)) {
          filters[key] = val
        }
      }

      let queryParams = {
        page: this.yachtSalesSlots.pagination.page,
        per_page: this.yachtSalesSlots.pagination.perPage,
        order_by: this.yachtSalesSlots.sorting.sortBy,
        order: this.yachtSalesSlots.sorting.desc === undefined ? undefined : this.yachtSalesSlots.sorting.desc ? 'desc' : 'asc',
        ...filters
      }

      try {
        let result = await YachtSalesSlot.api.fetch(queryParams)

        this.yachtSalesSlots.data = result.data
        this.yachtSalesSlots.meta = result.meta

        this.yachtSalesSlots.count = (await YachtSalesSlot.api.fetch({ ...queryParams, count: true })).count
      } catch (e) {
        this.$store.dispatch('alert', {
          'text': 'Something went wrong',
          'color': 'error'
        })
        throw e
      } finally {
        this.yachtSalesSlots.loading = false
      }
    }, 500),
    async fetchYachtModels() {
      this.yachtModels.loading = true
      try {
        this.yachtModels.data = await YachtModel.api.fetch({
          status: YachtModel.STATUS_ACTIVE
        })
      } catch (error) {

      } finally {
        this.yachtModels.loading = false
      }
    },
    async fetchOwners() {
      if (!this.$can('view', 'Owner')) return

      this.owners.loading = true

      try {
        this.owners.data = await Owner.api.getOwners()
      } catch (error) {
        throw error
      } finally {
        this.owners.loading = false
      }
    },
    async fetchFinanceModelTypes() {
      this.financeModelTypes.loading = true

      this.financeModelTypes.data = await FinanceModel.api.getTypes()

      this.financeModelTypes.loading = false
    },
    yachtCreated(yacht) {
      this.$router.push({ name: 'yachtDashboard', params: { id: yacht.id } })
    },
    openYachtEditDialog() {
      this.yachtEditDialog = true
    }
  }
}
</script>
